import { useMutation, useQueryClient } from "@tanstack/react-query";
import { assignCustomer, assignCustomers } from "src/redux/api/employee.api";
import { customerKeys } from "./useFetchCustomers";

export const useAssignCustomers = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      employeeId,
      customerIds,
    }: {
      employeeId: number;
      customerIds: number[];
    }) => assignCustomers(employeeId, customerIds),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: customerKeys.all,
      });
    },
  });
};

export const useAssignCustomer = () => {
  return useMutation({
    mutationFn: ({
      employeeId,
      customerId,
    }: {
      employeeId: number;
      customerId: number;
    }) => assignCustomer(employeeId, customerId),
  });
};
